import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import CloseButton from '../buttons/CloseButton';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'relative',
      right: 0,
      width: 420,
      height: '100%',
      boxShadow: '-3px 2px 5px 1px rgba(0, 0, 0, 0.3)',
      overflow: 'auto',
      padding: '20px',
      background: theme.palette.grey['100'],
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    modalRoot: {
      '& .MuiBackdrop-root': {
        backgroundColor: 'unset',
      },
    },
    paperRoot: {
      top: 70,
      height: 'calc(100% - 70px)',
    },
  }),
);

interface Props {
  toggleHelpModal: (props: any) => void;
  visible: boolean;
}

const HelpModal: React.FC<Props> = ({ toggleHelpModal, visible, children }) => {
  const classes = useStyles();

  return (
    <div>
      <SwipeableDrawer
        anchor="right"
        open={visible}
        onClose={() => toggleHelpModal(false)}
        onOpen={() => toggleHelpModal(true)}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
          disablePortal: true,
        }}
        classes={{
          modal: classes.modalRoot,
          paper: classes.paperRoot,
        }}
      >
        <div className={classes.root}>
          <CloseButton togglePopup={(open: boolean) => toggleHelpModal(open)} />
          {children}
        </div>
      </SwipeableDrawer>
    </div>
  );
};

export default HelpModal;
